import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { StarsRating } from "@/modules/theme/components/Stars/StarsRating";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

const translationNamespace = "pages/SubtaskDetailsPage";

type SubtaskRatingProps = {
  rating: number | null;
  comment: string;
};

export const SubtaskRating: React.FC<SubtaskRatingProps> = ({
  rating,
  comment,
}) => {
  const classes = createSubtaskRating(useTheme());
  const { t } = useTranslation(translationNamespace);
  return (
    <>
      <div className={classes.row}>
        <Typography variant="contentMedium" className={classes.label}>
          {t("Task rating")}
        </Typography>
        {rating ? (
          <StarsRating size={22} value={rating} />
        ) : (
          <Typography variant="contentMedium" className={classes.emptyContent}>
            {t("Not yet")}
          </Typography>
        )}
      </div>

      <div className={classes.row}>
        <Typography variant="contentMedium" className={classes.label}>
          {t("Comments")}
        </Typography>
        {comment ? (
          <Typography variant="contentMedium" className={classes.text}>
            {comment}
          </Typography>
        ) : (
          <Typography variant="contentMedium" className={classes.emptyContent}>
            {t("Not yet")}
          </Typography>
        )}
      </div>
    </>
  );
};

function createSubtaskRating({ typography, spacing }: Theme) {
  return {
    row: css({
      marginBottom: spacing(2),
    }),
    label: css({
      fontWeight: typography.fontWeight.semiBold,
      fontFamily: typography.fonts.body,
      marginBottom: spacing(1),
    }),
    text: css({
      lineHeight: 1.5,
    }),
    emptyContent: css({
      color: grey[500],
    }),
  };
}
